<!--スタッフ基本情報-->
<template>
  <div>
    <!-- 基本情報 -->
    <div style="margin-top:5px">
      <!-- 表头文字 -->
      <el-row :gutter="0" style="background-color:#3cc6fa;">
        <div class="table-header">{{$t('MODULE.I0001_LBL_BASIC_INFO')}}</div>
      </el-row>
      <table class="i0001-table table-label">
        <!-- スタッフCD -->
        <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_STAFF_CD')}}</td>
          <td class="i0001-form-value">{{this.staffCd}}</td>
        </tr>
        <!-- 氏名 -->
        <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_USERNAME')}}</td>
          <td class="i0001-form-value">{{this.userName}}</td>
        </tr>
        <!-- 生年月日 -->
        <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_BIRTHDAY')}}</td>
          <td class="i0001-form-value">{{this.birthday}}</td>
        </tr>
        <!-- 性別 -->
        <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_GENDER')}}</td>
          <td class="i0001-form-value" v-if="this.gender == 1">{{$t('MODULE.I0001_MSG_GENDERA')}}</td>
          <td class="i0001-form-value" v-if="this.gender == 2">{{$t('MODULE.I0001_MSG_GENDERB')}}</td>
        </tr>
        <!-- 郵便番号 -->
        <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_ZIPCODE')}}</td>
          <td class="i0001-form-value">
            <el-input class="i0001-input" style="width:55px" maxlength="3" v-model="postCd1" :readonly="false" @input="postCd1 = postCd1.replace(/[^\d]/g, '');"></el-input> -
            <el-input class="i0001-input" style="width:65px" maxlength="4" v-model="postCd2" :readonly="false" @input="postCd2 = postCd2.replace(/[^\d]/g, '');"></el-input>
            <!---住所取得ボタン -->
            <el-button class="i0001-css-addressbtn" @click="address_click">{{$t('MODULE.I0001_LBL_GET_ADDRESS')}}</el-button><span style="color:red;">＊</span>
          </td>
        </tr>
        <!-- 住所 -->
        <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_ADDRESS')}}</td>
          <td class="i0001-form-value">
            <el-input class="i0001-input" v-model="address1"></el-input><span style="color:red">＊</span>
            <el-input class="i0001-input" style="margin-top:3px" v-model="address2"></el-input>
            <el-input class="i0001-input" style="margin-top:3px" v-model="address3"></el-input>
          </td>
        </tr>
        <!-- 最寄り駅 -->
        <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_NEAREST_STATION')}}</td>
          <td class="i0001-form-value">
            <el-autocomplete class="i0001-input" v-model="nearestStation" :fetch-suggestions="(queryString,cb)=>{ekiStationSearch(queryString,cb,'station')}" :maxlength="100"></el-autocomplete>
          </td>
        </tr>
        <!-- 最寄りバス停 -->
        <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_NEAREST_STATION_BUS')}}</td>
          <td class="i0001-form-value">
            <el-autocomplete class="i0001-input" v-model="nearestStationBus" :fetch-suggestions="(queryString,cb)=>{ekiStationSearch(queryString,cb,'bus')}" :maxlength="100"></el-autocomplete>
          </td>
        </tr>
        <!-- 携帯番号 -->
        <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_TEL_NUMBER')}}</td>
          <td class="i0001-form-value">
            <el-input class="i0001-input" style="width:64px" v-model="mobileNo1" pattern="\d*" maxlength="4" @input="mobileNo1 = mobileNo1.replace(/[^\d]/g, '');"></el-input> -
            <el-input class="i0001-input" style="width:64px" v-model="mobileNo2" pattern="\d*" maxlength="4" @input="mobileNo2 = mobileNo2.replace(/[^\d]/g, '');"></el-input> -
            <el-input class="i0001-input" style="width:64px" v-model="mobileNo3" pattern="\d*" maxlength="4" @input="mobileNo3 = mobileNo3.replace(/[^\d]/g, '');"></el-input>
          </td>
        </tr>
        <!-- 電話番号 -->
        <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_HOME_NUMBER')}}</td>
          <td class="i0001-form-value">
            <el-input class="i0001-input" style="width:64px" v-model="phoneNo1" pattern="\d*" maxlength="4" @input="phoneNo1 = phoneNo1.replace(/[^\d]/g, '');"></el-input> -
            <el-input class="i0001-input" style="width:64px" v-model="phoneNo2" pattern="\d*" maxlength="4" @input="phoneNo2 = phoneNo2.replace(/[^\d]/g, '');"></el-input> -
            <el-input class="i0001-input" style="width:64px" v-model="phoneNo3" pattern="\d*" maxlength="4" @input="phoneNo3 = phoneNo3.replace(/[^\d]/g, '');"></el-input>
          </td>
        </tr>
        <!-- 携帯メール -->
        <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_TEL_MAIL')}}</td>
          <td class="i0001-form-value">
            <el-input class="i0001-input" maxlength="100" v-model="mobileMail"></el-input>
          </td>
        </tr>
        <!-- PCメール -->
        <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_PC_MAIL')}}</td>
          <td class="i0001-form-value">
            <el-input class="i0001-input" maxlength="100" v-model="pcMail"></el-input>
          </td>
        </tr>
        <!-- マイカー使用 -->
        <!-- del by chaiz 20240606 start -->
        <!-- <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_MYCAR_USE')}}</td>
          <td class="i0001-form-value" style="padding-left:15px">
            <el-radio v-model="mycarUse" label="1">
              <span>{{$t('MODULE.I0001_RDO_YU')}}</span>
            </el-radio>
            <el-radio v-model="mycarUse" label="0">
              <span>{{$t('MODULE.I0001_RDO_MU')}}</span>
            </el-radio><span style="float;color:red;margin-left:-20px;">＊</span>
          </td>
        </tr> -->
        <!-- del by chaiz 20240606 end -->
        <!-- 所属部門 -->
        <tr>
          <td class="i0001-form-label">{{$t('MODULE.I0001_LBL_SALESOFFICE')}}</td>
          <td class="i0001-form-value">{{this.salesOffice}}</td>
        </tr>
      </table>
      <!--申請中-->
      <span style="font-size: 13px;" v-if="this.processCd == 1">{{this.statusName}}&nbsp;{{this.timeShow}}</span>
      <!-- 申请按钮 -->
      <div style="text-align:center">
        <el-button class="i0001-css-btn" @click="apply_click">{{$t('MODULE.I0001_LBL_APPLY')}}</el-button>
      </div>
    </div>
    <div>
      <DialogAddress :visible.sync="showAddressDialog" v-if="showAddressDialog" :show="showAddressDialog" :mainpostcode="addressPostCode" @closeAddressDialog="closeAddressDialog" @submitAddressDialog="submitAddressDialog"></DialogAddress>
    </div>
  </div>
</template>
<script>
import * as amsApi from "../api/i_0001"
import css from "@/statics/css"
import DialogAddress from '@/components/page/dialogAddress'
import utils from '../../common/utils'
import encoding from 'encoding-japanese';
let url = require('@/../config/sysConfig')
export default {
  mixins: [css],
  components: {
    "DialogAddress": DialogAddress,
  },
  data() {
    return {
      //スタッフCD
      staffCd: "",
      //氏名
      userName: "",
      //生年月日
      birthday: "",
      //性別
      gender: "",
      //郵便番号
      postCd1: "",
      postCd2: "",
      //住所1
      address1: "",
      //住所2
      address2: "",
      //住所3
      address3: "",
      //最寄り駅
      nearestStation: "",
      //最寄りバス停
      nearestStationBus: "",
      //携帯番号
      mobileNo1: "",
      mobileNo2: "",
      mobileNo3: "",
      //電話番号
      phoneNo1: "",
      phoneNo2: "",
      phoneNo3: "",
      //携帯メール
      mobileMail: "",
      //PCメール
      pcMail: "",
      //営業所
      salesOffice: "",
      //申請日時
      applyDate: "",
      //申請ステータス
      status: "",
      //ステータス名
      statusName: "",
      //申請番号
      id: "",
      //処理区分
      processCd: "",
      //確認日時
      confirmDate: "",
      //更新日時
      updateDate: "",
      //日時表示
      timeShow: "",
      userCd: "",
      showAddressDialog: false,
      //マイカー使用 0：無；1：有
      mycarUse: "",
      //郵便番号(住所取得ボタン用)
      addressPostCode: "",
      //緯度
      latitude: "",
      //経度
      longitude: "",
      //市区町村CD
      cityCD: ""
    }
  },
  created() {
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
    //検索
    this.query();
  },
  methods: {
    // 検索
    query() {
      // loading处理
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
      // 検索処理
      amsApi.i_0001_query(this.userCd).then(res => {
        if (res.code == 204) {
          console.log(res)
          this.staffCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
          this.userName = res.items.selfDoc[0].userName;
          this.birthday = res.items.selfDoc[0].birthday;
          this.gender = res.items.selfDoc[0].gender;

          if (res.items.selfDoc[0].PostCd == null) {
            this.postCd1 = "";
            this.postCd2 = "";
          } else {
            this.postCd1 = res.items.selfDoc[0].PostCd.split("-")[0];
            this.postCd2 = res.items.selfDoc[0].PostCd.split("-")[1];
          }

          this.address1 = res.items.selfDoc[0].address1;
          this.address2 = res.items.selfDoc[0].address2;
          this.address3 = res.items.selfDoc[0].address3;

          if (res.items.selfDoc[0].nearestStation == null) {
            this.nearestStation = ""
          } else {
            this.nearestStation = res.items.selfDoc[0].nearestStation;
          }

          if (res.items.selfDoc[0].nearestStationBus == null) {
            this.nearestStationBus = ""
          } else {
            this.nearestStationBus = res.items.selfDoc[0].nearestStationBus;
          }

          if (res.items.selfDoc[0].MobileNo == null) {
            this.mobileNo1 = "";
            this.mobileNo2 = "";
            this.mobileNo3 = "";
          } else {
            this.mobileNo1 = res.items.selfDoc[0].MobileNo.split("-")[0];
            this.mobileNo2 = res.items.selfDoc[0].MobileNo.split("-")[1];
            this.mobileNo3 = res.items.selfDoc[0].MobileNo.split("-")[2];
          }

          if (res.items.selfDoc[0].PhoneNo == null) {
            this.phoneNo1 = "";
            this.phoneNo2 = "";
            this.phoneNo3 = "";
          } else {
            this.phoneNo1 = res.items.selfDoc[0].PhoneNo.split("-")[0];
            this.phoneNo2 = res.items.selfDoc[0].PhoneNo.split("-")[1];
            this.phoneNo3 = res.items.selfDoc[0].PhoneNo.split("-")[2];
          }

          this.mobileMail = res.items.selfDoc[0].mobileMail;
          this.pcMail = res.items.selfDoc[0].pcMail;

          this.salesOffice = res.items.selfDoc[0].salesOfficeName;

          this.applyDate = res.items.selfDoc[0].applyDate;
          if (res.items.selfDoc[0].id == null) {
            this.id = "";
          } else {
            this.id = res.items.selfDoc[0].id;
          }

          this.processCd = res.items.selfDoc[0].processCd;

          this.status = res.items.selfDoc[0].status;
          this.statusName = res.items.selfDoc[0].statusName;
          this.confirmDate = res.items.selfDoc[0].confirmDate;
          this.updateDate = res.items.selfDoc[0].updateDate;
          //マイカー使用
          this.mycarUse = res.items.selfDoc[0].mycarUse;
          this.cityCD = res.items.selfDoc[0].cityCd;
          this.latitude = res.items.selfDoc[0].geoLocationLat;
          this.longitude = res.items.selfDoc[0].geoLocationLng;
          // 処理区分が「1：更新」表示日時
          // ステータス取得
          // 「0」の場合 申請日時
          // 「1」or「2」の場合 確認日時
          if (this.processCd == "1") {
            if (this.status == "0") {
              this.timeShow = utils.extractMillisecond(this.applyDate);
            } else if (this.status == "1" || this.status == "2") {
              this.timeShow = utils.extractMillisecond(this.confirmDate);
            }
          }

        } else if (res.code === 300) {
          this.loading.close();
          return
        }
        this.loading.close();
      }).catch(() => {
        this.loading.close();
      });
    },
    // 申请
    apply_click() {
      if (this.postCd1 == null) {
        this.postCd1 = ""
      }
      if (this.postCd2 == null) {
        this.postCd2 = ""
      }
      if (this.address1 == null) {
        this.address1 = ""
      }
      if (this.nearestStation == null) {
        this.nearestStation = ""
      }
      if (this.nearestStationBus == null) {
        this.nearestStationBus = ""
      }
      if (this.mobileNo1 == null) {
        this.mobileNo1 = ""
      }
      if (this.mobileNo2 == null) {
        this.mobileNo2 = ""
      }
      if (this.mobileNo3 == null) {
        this.mobileNo3 = ""
      }
      if (this.phoneNo1 == null) {
        this.phoneNo1 = ""
      }
      if (this.phoneNo2 == null) {
        this.phoneNo2 = ""
      }
      if (this.phoneNo3 == null) {
        this.phoneNo3 = ""
      }
      if (this.mobileMail == null) {
        this.mobileMail = ""
      }
      if (this.pcMail == null) {
        this.pcMail = ""
      }
      if (this.cityCD == null) {
        this.cityCD = ""
      }

      //チェック処理
      //必須項目のいずれが入力されていない場合
      //郵便番号
      if (this.postCd1 + this.postCd2 == "") {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0001_LBL_ZIPCODE')), showClose: true })
        return false
      }

      //郵便番号桁数チェック
      if (this.postCd1.length != 3 || this.postCd2.length != 4) {
        this.$message.error({ message: this.$t('MODULE.DIALOG_MSG_POST_CODE_CHECK'), showClose: true });
        return false
      }

      //住所1
      if (this.address1 == "") {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0001_MSG_ADDRESS1')), showClose: true })
        return false
      }

      //最寄り駅とも最寄りバス停両方入力していない場合
      if (this.nearestStation == "" && this.nearestStationBus == "") {
        this.$message.error({ message: this.$t('MODULE.I0001_MSG_WHICH_VALIDITY').replace('{1}', this.$t('MODULE.I0001_LBL_NEAREST_STATION')).replace('{2}', this.$t('MODULE.I0001_LBL_NEAREST_STATION_BUS')), showClose: true })
        return false
      }

      //携帯番号と電話番号両方入力していない場合
      if (this.mobileNo1 + this.mobileNo2 + this.mobileNo3 == "" && this.phoneNo1 + this.phoneNo2 + this.phoneNo3 == "") {
        this.$message.error({ message: this.$t('MODULE.I0001_MSG_WHICH_VALIDITY').replace('{1}', this.$t('MODULE.I0001_LBL_TEL_NUMBER')).replace('{2}', this.$t('MODULE.I0001_LBL_HOME_NUMBER')), showClose: true })
        return false
      }

      //携帯メールとPCメール両方入力していない場合
      if (this.mobileMail == "" && this.pcMail == "") {
        this.$message.error({ message: this.$t('MODULE.I0001_MSG_WHICH_VALIDITY').replace('{1}', this.$t('MODULE.I0001_LBL_TEL_MAIL')).replace('{2}', this.$t('MODULE.I0001_LBL_PC_MAIL')), showClose: true })
        return false
      }

      //携帯メールアドレス正確性チェック
      if (this.mobileMail != "") {
        var regu = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
        var re = new RegExp(regu);
        if (!re.test(this.mobileMail)) {
          this.$message.error({ message: this.$t('COMMON.MSG_ERROR_MAIL_ADDRESS'), showClose: true });
          return false
        }
      }

      //PCメールアドレス正確性チェック
      if (this.pcMail != "") {
        var regu = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
        var re = new RegExp(regu);
        if (!re.test(this.pcMail)) {
          this.$message.error({ message: this.$t('COMMON.MSG_ERROR_MAIL_ADDRESS'), showClose: true });
          return false
        }
      }

      //マイカー使用入力必須
      //del by chaiz 20240606 start
      // if (this.mycarUse == "" || this.mycarUse == null) {
      //   this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0001_LBL_MYCAR_USE')), showClose: true })
      //   return false
      // }
      //del by chaiz 20240606 end

      // データを保存します。よろしいでしょうか？
      // 「はい」を選択したら、下記の処理へ進む
      // 「いいえ」を選択したら、何もしない
      this.$confirm(this.$t('COMMON.MSG_CONFIRM_CHANGE'), this.$t('COMMON.CONFIRM'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//を選択します
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//キャンセル
        center: true
      }).then(() => {
        //はい
        var update_params = {};

        update_params.userCd = this.staffCd;
        update_params.postCd = this.postCd1 + "-" + this.postCd2;
        update_params.address1 = this.address1;
        if (this.address2 == null) {
          update_params.address2 = "";
        } else {
          update_params.address2 = this.address2;
        }

        if (this.address3 == null) {
          update_params.address3 = "";
        } else {
          update_params.address3 = this.address3;
        }

        update_params.nearestStation = this.nearestStation;
        update_params.nearestStationBus = this.nearestStationBus;
        if (this.mobileNo1 + this.mobileNo2 + this.mobileNo3 == "") {
          update_params.mobileNo = "";
        } else {
          update_params.mobileNo = this.mobileNo1 + "-" + this.mobileNo2 + "-" + this.mobileNo3;
        }
        if (this.phoneNo1 + this.phoneNo2 + this.phoneNo3 == "") {
          update_params.phoneNo = "";
        } else {
          update_params.phoneNo = this.phoneNo1 + "-" + this.phoneNo2 + "-" + this.phoneNo3;
        }
        update_params.mobileMail = this.mobileMail;
        update_params.pcMail = this.pcMail;

        update_params.processCd = this.processCd;

        if (this.processCd == "2") {
          update_params.updateDate = "";
          update_params.id = null;
        } else {
          update_params.updateDate = this.updateDate;
          update_params.id = this.id;
        }

        update_params.mycarUse = this.mycarUse;

        update_params.cityCd = this.cityCD;

        if (this.latitude != null && this.latitude != "") {
          update_params.geoLocationLat = Number(this.latitude);
        }
        if (this.longitude != null && this.longitude != "") {
          update_params.geoLocationLng = Number(this.longitude);
        }
        amsApi.i_0001_update(update_params, this.userCd).then(res => {
          if (res.code === 202) {
            this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) // 更新成功
            this.query()
          } else if (res.code === 308) {
            setTimeout(() => {
              this.$confirm(this.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
                confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
                cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
                center: true
              }).then(() => {
                this.query();
              }).catch(() => {
              })
            }, 500)
          } else if (res.code === 311) {
            setTimeout(() => {
              this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//保存失敗
            }, 500)
          }
        });
      }).catch(() => {
        //いいえ
      });
    },

    address_click() {
      //将当前郵便番号的值取得,传递到住所Dialog
      if (this.postCd1 == null) {
        this.postCd1 = ""
      }
      if (this.postCd2 == null) {
        this.postCd2 = ""
      }

      if (this.postCd1 + this.postCd2 == "") {
        this.addressPostCode = "";
      } else {
        this.addressPostCode = this.postCd1 + "-" + this.postCd2;
      }

      this.showAddressDialog = true;
    },
    // 选择住所对话框弹窗回调
    submitAddressDialog(row) {
      //住所1:都道府県＋市区町村
      //住所2:大字町丁目＋番地
      for (const key in row) {
        if (row[key] == null) {
          row[key] = ""
        }
      }
      this.showAddressDialog = false;
      this.address1 = row.stateName + row.cityName;
      this.address2 = row.oazamachiChomName + row.addressBanchi;
      this.address3 = "";
      this.latitude = row.latitude;
      this.longitude = row.longitude;
      this.cityCD = row.cityCD;
      // this.postCd1 = row.postCode.split("-")[0];
      // this.postCd2 = row.postCode.split("-")[1];
    },
    // 关闭住所对话框的弹窗回调
    closeAddressDialog() {
      this.showAddressDialog = false;
    },
    ekiStationSearch(queryString, cb, type) {
      var keyword = queryString;
      // キーワードを文字コードの数値の配列に変換
      var unicodeArray = [];
      for (let i = 0; i < keyword.length; i++) {
        unicodeArray.push(keyword.charCodeAt(i));
      }
      var sjisArray = encoding.convert(unicodeArray, {
        to: 'SJIS',
        from: 'UNICODE',
      });
      var encodedKeyword = encoding.urlEncode(sjisArray);
      amsApi.requestEkiStationGet(encodedKeyword, type).then(res => {
        var tempEkiArrey = res.split('&')
        var retEkiArrey = []
        tempEkiArrey.forEach((item, i) => {
          var tempsplit = item.split('=')
          var tempObjEki = { value: tempsplit[1] }
          if (i !== 0 && i !== tempEkiArrey.length - 1 & i !== tempEkiArrey.length - 2) {
            retEkiArrey.push(tempObjEki)
          }
        });
        cb(retEkiArrey)
      })
    },

    UTF8ToSJIS(data) {
      var results = [];
      var i = 0;
      var len = data && data.length;
      var b, b1, b2, utf8, jis;

      for (; i < len; i++) {
        b = data[i];
        if (b >= 0x80) {
          if (b <= 0xDF) {
            // 2 bytes.
            utf8 = (b << 8) + data[++i];
          } else {
            // 3 bytes.
            utf8 = (b << 16) +
              (data[++i] << 8) +
              (data[++i] & 0xFF);
          }
          jis = UTF8_TO_JIS_TABLE[utf8];
          if (jis === void 0) {
            //  *** 変更の開始
            //  UTF8の円記号(\)をSJISのバックスラッシュ(表記上は\)に変換 
            if (utf8 == 0xC2A5) {
              results[results.length] = 0x5C;
            } else {
              results[results.length] = UTF8_UNKNOWN;
            }
            //  *** 変更の終了
            // 元のコード        
            //results[results.length] = UTF8_UNKNOWN;
          } else {
            if (jis < 0xFF) {
              results[results.length] = jis + 0x80;
            } else {
              if (jis > 0x10000) {
                jis -= 0x10000;
              }

              b1 = jis >> 8;
              b2 = jis & 0xFF;
              if (b1 & 0x01) {
                b1 >>= 1;
                if (b1 < 0x2F) {
                  b1 += 0x71;
                } else {
                  b1 -= 0x4F;
                }

                if (b2 > 0x5F) {
                  b2 += 0x20;
                } else {
                  b2 += 0x1F;
                }
              } else {
                b1 >>= 1;
                if (b1 <= 0x2F) {
                  b1 += 0x70;
                } else {
                  b1 -= 0x50;
                }
                b2 += 0x7E;
              }
              results[results.length] = b1 & 0xFF;
              results[results.length] = b2 & 0xFF;
            }
          }
        } else {
          results[results.length] = data[i] & 0xFF;
        }
      }
      return results;
    }

  }
}
</script>
<style>
/* 表格边框、字体样式 */
.i0001-table {
  border-collapse: collapse;
  width: 100%;
}
/* 表格边框颜色 */
.i0001-table,
.i0001-table tr td {
  border: 1px solid #ccc;
}
.i0001-form-value,
.i0001-form-value tr td {
  padding-right: 0 !important;
}
/* 表格内边距 */
.i0001-table td {
  padding: 5px 8px;
}
/* 表格第一列背景色、宽度、文字居右 */
.i0001-form-label {
  text-align: right;
  width: 80px;
  background: #d2eef8;
}
/* 表格第二列背景色 */
.i0001-form-value {
  background: #fafafa;
}
/* input框宽度 */
.i0001-input {
  width: 94%;
  font-size: 12px;
}
ul.decimal {
  list-style-type: decimal;
  padding-inline-start: 25px;
}
.i0001-form-value .el-button--small,
.el-button--small.is-round {
  padding-left: 9px;
  padding-right: 9px;
}
/* 按钮样式 */
.i0001-css-btn {
  color: #fff;
  margin-top: 15px;
  width: 20%;
  height: 40px;
  padding-top: 10px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
}
/*按钮经过样式*/
.i0001-css-btn:hover {
  color: #fff;
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
}

/*按钮激活和焦点样式*/
.i0001-css-btn:active,
.i0001-css-btn:focus {
  color: #fff;
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
}
/* 按钮样式 */
.i0001-css-addressbtn {
  color: #fff;
  margin-top: 0px;
  width: 81px;
  height: 100%;
  padding-left: 12px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
}
/*按钮经过样式*/
.i0001-css-addressbtn:hover {
  color: #fff;
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
}

/*按钮激活和焦点样式*/
.i0001-css-addressbtn:active,
.i0001-css-addressbtn:focus {
  color: #fff;
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0001.vue